export default __webpack_public_path__ + "static/Artificial_Light_Outdoor-f46a08d31ca96741157658fb922c0ea6.avif";